/* Lionzen · buscador popup.
   - Índice local (nombre + ingredientes de cada fórmula) para resultados instantáneos.
   - Búsqueda predictiva de Shopify para completar con productos, colecciones y artículos.
   Abre con cualquier [data-lzs-open] (la lupa de la cabecera) o con la tecla "/". */
(function () {
  'use strict';
  if (window.LZSearch) return;
  var cfgEl = document.getElementById('lzsearch-config');
  var root = document.getElementById('lzs');
  if (!cfgEl || !root) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var cart = {}; try { cart = JSON.parse(document.getElementById('lzcart-config').textContent); } catch (e) {}
  var T = C.t, input = root.querySelector('[data-lzs-input]'), body = root.querySelector('[data-lzs-body]'), clearBtn = root.querySelector('[data-lzs-clear]');
  var products = (cart.upsell || []), bottles = (cart.bottles || []);
  var reqId = 0, timer = null;
  document.body.appendChild(root);

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function money(c) {
    var v = (Math.round(c) / 100).toFixed(2).split('.'); v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return String(cart.money || '{' + '{amount_with_comma_separator}}€').replace(/\{\{\s*amount[^}]*\}\}/, v.join(',')).replace(/<[^>]+>/g, '');
  }
  function keyOf(title) { var k = norm(title); for (var i = 0; i < bottles.length; i++) { if (k.indexOf(norm(bottles[i].k)) > -1) return bottles[i]; } return null; }
  function shortT(t) { return String(t || '').replace(/^lionzen\s+/i, ''); }
  function hl(text, q) {
    var t = esc(text); if (!q) return t;
    var i = norm(text).indexOf(norm(q)); if (i < 0) return t;
    return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  }

  /* índice local */
  var local = products.filter(function (p) { return !/pack/i.test(p.t); }).map(function (p) {
    var b = keyOf(p.t), idx = b ? (C.index[b.k] || '') : '';
    return { p: p, b: b, hay: norm(p.t + ' ' + idx), ings: idx };
  });
  function localSearch(q) {
    var nq = norm(q).trim(); if (!nq) return [];
    var words = nq.split(/\s+/);
    return local.map(function (x) {
      var score = 0, hit = '';
      words.forEach(function (w) {
        if (norm(x.p.t).indexOf(w) > -1) score += 10;
        else if (x.hay.indexOf(w) > -1) {
          score += 5;
          if (!hit) { var m = x.ings.split(' ').filter(function (t) { return norm(t).indexOf(w) === 0; })[0]; hit = m || w; }
        }
      });
      return { x: x, s: score, hit: hit };
    }).filter(function (r) { return r.s > 0; }).sort(function (a, b) { return b.s - a.s; }).slice(0, 6);
  }

  function productRow(p, b, sub, q) {
    var img = b ? '<img src="' + esc(b.sm) + '" alt="" loading="lazy">' : (p.img ? '<img class="is-photo" src="' + esc(p.img) + '" alt="" loading="lazy">' : '');
    return '<a class="lzs__p" href="' + esc(p.u) + '" style="--l-bg:' + esc(b ? b.bg : '#F4F4F2') + '">' +
      '<span class="lzs__pm">' + img + '</span>' +
      '<span class="lzs__pi"><b>' + hl(shortT(p.t), q) + '</b>' + (sub ? '<i>' + sub + '</i>' : '') + '</span>' +
      (p.p != null ? '<span class="lzs__pp">' + esc(typeof p.p === 'number' ? money(p.p) : p.p) + '</span>' : '') +
      '<span class="lzs__go" aria-hidden="true">→</span></a>';
  }

  function idle() {
    var chips = (C.popular || []).map(function (w) { return '<button type="button" class="lzs__chip" data-lzs-q="' + esc(w) + '">' + esc(w) + '</button>'; }).join('');
    var grid = local.map(function (x) {
      return '<a class="lzs__f" href="' + esc(x.p.u) + '" style="--l-bg:' + esc(x.b ? x.b.bg : '#F4F4F2') + '">' +
        (x.b ? '<img src="' + esc(x.b.sm) + '" alt="" loading="lazy">' : '') + '<span>' + esc(shortT(x.p.t)) + '</span></a>';
    }).join('');
    body.innerHTML = '<div class="lzs__sec"><div class="lzs__h">' + esc(T.pop) + '</div><div class="lzs__chips">' + chips + '</div></div>' +
      '<div class="lzs__sec"><div class="lzs__h">' + esc(T.ours) + '</div><div class="lzs__grid">' + grid + '</div></div>';
  }

  function render(q, remote) {
    var loc = localSearch(q);
    var seen = {}, rows = [];
    loc.forEach(function (r) {
      seen[r.x.p.u.split('?')[0]] = 1;
      rows.push(productRow(r.x.p, r.x.b, r.hit ? esc(T.has) + ': ' + hl(r.hit, q) : '', q));
    });
    var rp = (remote && remote.products) || [];
    rp.forEach(function (p) {
      var u = String(p.url || '').split('?')[0]; if (seen[u]) return; seen[u] = 1;
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      rows.push(productRow({ t: p.title, u: p.url, p: p.price ? String(p.price).replace('.', ',') + ' €' : null, img: img }, keyOf(p.title), '', q));
    });
    var cols = ((remote && remote.collections) || []).map(function (c) { return '<a class="lzs__chip lzs__chip--link" href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>'; }).join('');
    var arts = ((remote && remote.articles) || []).slice(0, 4).map(function (a) {
      var im = a.image ? '<img src="' + esc(a.image) + '" alt="" loading="lazy">' : '';
      return '<a class="lzs__a" href="' + esc(a.url) + '"><span class="lzs__am">' + im + '</span><span>' + hl(a.title, q) + '</span></a>';
    }).join('');
    if (!rows.length && !cols && !arts) {
      body.innerHTML = '<div class="lzs__none"><b>' + esc(T.none) + ' “' + esc(q) + '”</b><span>' + esc(T.noneSub) + '</span></div>';
      idleAppend();
      return;
    }
    body.innerHTML =
      (rows.length ? '<div class="lzs__sec"><div class="lzs__h">' + esc(T.prods) + '</div><div class="lzs__list">' + rows.join('') + '</div></div>' : '') +
      (cols ? '<div class="lzs__sec"><div class="lzs__h">' + esc(T.cols) + '</div><div class="lzs__chips">' + cols + '</div></div>' : '') +
      (arts ? '<div class="lzs__sec"><div class="lzs__h">' + esc(T.arts) + '</div><div class="lzs__arts">' + arts + '</div></div>' : '') +
      '<a class="lzs__all" href="' + esc(C.url) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(T.all) + ' “' + esc(q) + '” →</a>';
  }
  function idleAppend() {
    var chips = (C.popular || []).map(function (w) { return '<button type="button" class="lzs__chip" data-lzs-q="' + esc(w) + '">' + esc(w) + '</button>'; }).join('');
    body.insertAdjacentHTML('beforeend', '<div class="lzs__sec"><div class="lzs__h">' + esc(T.pop) + '</div><div class="lzs__chips">' + chips + '</div></div>');
  }

  function search(q) {
    q = q.trim();
    clearBtn.hidden = !q;
    if (!q) { idle(); return; }
    render(q, null);
    var my = ++reqId;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var url = C.suggest + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (my !== reqId || !j) return; render(q, (j.resources && j.resources.results) || null); })
        .catch(function () {});
    }, 180);
  }

  function open() {
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    if (window.LZOverlay) window.LZOverlay.hide();
    document.documentElement.classList.add('lzs-lock', 'lz-ov');
    if (!input.value) idle(); else search(input.value);
    setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lzs-lock');
    if (!document.documentElement.classList.contains('lzd-lock')) { document.documentElement.classList.remove('lz-ov'); if (window.LZOverlay) window.LZOverlay.show(); }
  }

  input.addEventListener('input', function () { search(input.value); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lzs-open]')) { e.preventDefault(); open(); return; }
    if (!root.contains(e.target)) return;
    if (e.target.closest('[data-lzs-close]')) { close(); return; }
    if (e.target.closest('[data-lzs-clear]')) { input.value = ''; search(''); input.focus(); return; }
    var chip = e.target.closest('[data-lzs-q]');
    if (chip) { input.value = chip.getAttribute('data-lzs-q'); search(input.value); input.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    if (e.key === '/' && !root.classList.contains('is-open') && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '')) { e.preventDefault(); open(); }
  });
  window.LZSearch = { open: open, close: close };
})();
